import script from "./Skillset.vue?vue&type=script&setup=true&lang=js"
export * from "./Skillset.vue?vue&type=script&setup=true&lang=js"

import "./Skillset.vue?vue&type=style&index=0&id=b0e1cd0a&lang=sass&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b0e1cd0a"]])

export default __exports__